// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index_wrapper__GFqB3","wrapper_left":"index_wrapper_left__NWje6","wrapper_right":"index_wrapper_right__CMyAJ"};